import { UpdateGroupRequest, UpdateGroupResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export const updateGroup = makeCloudFunction<
  UpdateGroupRequest,
  UpdateGroupResponse
>("group", "updateGroup");
